// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skitterbook-image-cropper-container {
    width: fit-content;
    position: relative;
}

    .skitterbook-image-cropper-container > img {
        height: 12rem;        
    }

.skitterbook-image-crop {
    position: absolute;
    border: 2px solid #00f;
    background-color: rgba(0, 0, 255, 0.2);
    cursor: move;
    touch-action: none;
    opacity: 1;
    aspect-ratio: var(--crop-aspect-ratio);
    transition: opacity 0.5s ease;
    touch-action: none;
    -webkit-touch-callout: none; /* prevents context menu */
}

.skitterbook-image-cropper-container.horizontal.landscape:is(.req-rotation-0, .req-rotation-180) > .skitterbook-image-crop {
    height: 100%;
    left: var(--offsetX);
    top: var(--offsetY);
}

.skitterbook-image-cropper-container.vertical.landscape:is(.req-rotation-0, .req-rotation-180) > .skitterbook-image-crop {
    height: 100%;
    left: var(--offsetX);
    top: var(--offsetY);
}

.skitterbook-image-cropper-container.horizontal.portrait:is(.req-rotation-0, .req-rotation-180) > .skitterbook-image-crop {
    height: 100%;
    left: var(--offsetX);
    top: var(--offsetY);
}

.skitterbook-image-cropper-container.vertical.portrait:is(.req-rotation-0, .req-rotation-180) > .skitterbook-image-crop {
    width: 100%;
    left: var(--offsetX);
    top: var(--offsetY);
}

.skitterbook-image-cropper-container.horizontal.landscape:is(.req-rotation-90) > .skitterbook-image-crop {
    height: 100%;
    left: var(--offsetX);
    top: var(--offsetY);
    aspect-ratio: var(--inv-crop-aspect-ratio);
}

.skitterbook-image-cropper-container.vertical.landscape:is(.req-rotation-90) > .skitterbook-image-crop {
    height: 100%;
    left: var(--offsetX);
    top: var(--offsetY);
    aspect-ratio: var(--inv-crop-aspect-ratio);
}

.skitterbook-image-cropper-container.horizontal.portrait:is(.req-rotation-90) > .skitterbook-image-crop {
    height: 100%;
    left: var(--offsetX);
    top: var(--offsetY);
    aspect-ratio: var(--inv-crop-aspect-ratio);
}

.skitterbook-image-cropper-container.vertical.portrait:is(.req-rotation-90) > .skitterbook-image-crop {
    height: 100%;
    left: var(--offsetX);
    top: var(--offsetY);
    aspect-ratio: var(--inv-crop-aspect-ratio);
}

`, "",{"version":3,"sources":["webpack://./src/Skitterbook/css/SkitterBookImageCropper.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;IAEI;QACI,aAAa;IACjB;;AAEJ;IACI,kBAAkB;IAClB,sBAAsB;IACtB,sCAAsC;IACtC,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,sCAAsC;IACtC,6BAA6B;IAC7B,kBAAkB;IAClB,2BAA2B,EAAE,0BAA0B;AAC3D;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,0CAA0C;AAC9C","sourcesContent":[".skitterbook-image-cropper-container {\r\n    width: fit-content;\r\n    position: relative;\r\n}\r\n\r\n    .skitterbook-image-cropper-container > img {\r\n        height: 12rem;        \r\n    }\r\n\r\n.skitterbook-image-crop {\r\n    position: absolute;\r\n    border: 2px solid #00f;\r\n    background-color: rgba(0, 0, 255, 0.2);\r\n    cursor: move;\r\n    touch-action: none;\r\n    opacity: 1;\r\n    aspect-ratio: var(--crop-aspect-ratio);\r\n    transition: opacity 0.5s ease;\r\n    touch-action: none;\r\n    -webkit-touch-callout: none; /* prevents context menu */\r\n}\r\n\r\n.skitterbook-image-cropper-container.horizontal.landscape:is(.req-rotation-0, .req-rotation-180) > .skitterbook-image-crop {\r\n    height: 100%;\r\n    left: var(--offsetX);\r\n    top: var(--offsetY);\r\n}\r\n\r\n.skitterbook-image-cropper-container.vertical.landscape:is(.req-rotation-0, .req-rotation-180) > .skitterbook-image-crop {\r\n    height: 100%;\r\n    left: var(--offsetX);\r\n    top: var(--offsetY);\r\n}\r\n\r\n.skitterbook-image-cropper-container.horizontal.portrait:is(.req-rotation-0, .req-rotation-180) > .skitterbook-image-crop {\r\n    height: 100%;\r\n    left: var(--offsetX);\r\n    top: var(--offsetY);\r\n}\r\n\r\n.skitterbook-image-cropper-container.vertical.portrait:is(.req-rotation-0, .req-rotation-180) > .skitterbook-image-crop {\r\n    width: 100%;\r\n    left: var(--offsetX);\r\n    top: var(--offsetY);\r\n}\r\n\r\n.skitterbook-image-cropper-container.horizontal.landscape:is(.req-rotation-90) > .skitterbook-image-crop {\r\n    height: 100%;\r\n    left: var(--offsetX);\r\n    top: var(--offsetY);\r\n    aspect-ratio: var(--inv-crop-aspect-ratio);\r\n}\r\n\r\n.skitterbook-image-cropper-container.vertical.landscape:is(.req-rotation-90) > .skitterbook-image-crop {\r\n    height: 100%;\r\n    left: var(--offsetX);\r\n    top: var(--offsetY);\r\n    aspect-ratio: var(--inv-crop-aspect-ratio);\r\n}\r\n\r\n.skitterbook-image-cropper-container.horizontal.portrait:is(.req-rotation-90) > .skitterbook-image-crop {\r\n    height: 100%;\r\n    left: var(--offsetX);\r\n    top: var(--offsetY);\r\n    aspect-ratio: var(--inv-crop-aspect-ratio);\r\n}\r\n\r\n.skitterbook-image-cropper-container.vertical.portrait:is(.req-rotation-90) > .skitterbook-image-crop {\r\n    height: 100%;\r\n    left: var(--offsetX);\r\n    top: var(--offsetY);\r\n    aspect-ratio: var(--inv-crop-aspect-ratio);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
